<template >
    <div class="Tommorow">
        Tommorow - завтра
    </div>
</template>
<script>
export default {
    name: 'Tommorow'
}
</script>
<style lang="">
    
</style>